import ContentContainer from '@components/container/ContentContainer'
import ClientPageLayout from '@components/page/ClientPageLayout'
import QuizConcludeWarning from '@components/quiz/QuizConcludeWarning'
import QuizTimeline from '@components/quiz/QuizTimeline'
import QuizSectionEight from '@components/quiz/section/QuizSectionEight'
import QuizSectionFive from '@components/quiz/section/QuizSectionFive'
import QuizSectionFour from '@components/quiz/section/QuizSectionFour'
import QuizSectionOne from '@components/quiz/section/QuizSectionOne'
import QuizSectionSix from '@components/quiz/section/QuizSectionSix'
import QuizSectionThree from '@components/quiz/section/QuizSectionThree'
import QuizSectionTwo from '@components/quiz/section/QuizSectionTwo'
import QuizProvider from '@context/QuizContext'
import { Title, rem, Divider, Flex } from '@mantine/core'
import React from 'react'

const Quiz = () => {
    return (
        <QuizProvider>
            <ClientPageLayout bg='gray.0'>
                <ContentContainer
                    size='lg'
                    pos='relative'
                    pt={{ xs: rem(100), md: rem(50) }}
                >
                    <Flex
                        direction={{ base: 'column' }}
                        justify={{ xs: 'center', sm: 'space-between' }}
                    >
                        <Title
                            ta='center'
                            fz={{
                                md: '1.5rem',
                                lg: '2rem',
                            }}
                            order={3}
                            c='blue.6'
                        >
                            เกษียณอย่างมั่นใจ ด้วย{' '}
                            <span style={{ display: 'inline-block' }}>
                                MTL Retirement Check
                            </span>
                        </Title>
                        <Divider
                            my='lg'
                            color='gray.3'
                            maw={'70%'}
                            ml={'15%'}
                            mr={'15%'}
                        />
                        <Title
                            ta='center'
                            fz={{
                                xs: '1.1rem',
                                sm: '1.1rem',
                                md: '1.3rem',
                                lg: '1.5rem',
                            }}
                            fw={500}
                            mb={{ xs: 36, lg: 56 }}
                            order={3}
                            c='fuchasia.5'
                        >
                            <span style={{ display: 'inline-block' }}>
                                ชีวิตหลังเกษียณที่คุณใฝ่ฝันเป็นอย่างไร ?
                            </span>
                        </Title>
                    </Flex>
                    <QuizTimeline mb={56} />
                    <QuizSectionOne />
                    <QuizSectionTwo />
                    <QuizSectionThree />
                    <QuizSectionFour />
                    <QuizSectionFive />
                    <QuizSectionSix />
                    {/* <QuizSectionSeven /> */}
                    <QuizSectionEight />
                </ContentContainer>
                <QuizConcludeWarning />
            </ClientPageLayout>
        </QuizProvider>
    )
}

export default Quiz
